import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.click-card-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--click-card-slider' )[0], {
          pagination: false,
          arrows: true,
          gap: '12px',
          perPage: 2,
          perMove: 1,
          autoWidth: false,
          rewind: true,
          breakpoints: {
            960: {
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'click-card-slider', COMPONENT );
} )( app );
